"use strict";
import React from "react";
import documentsService from "./documents_service";
import IgnoreEntryView from "./ignore_entry_view";
import WaitingSpinner from "../components/waiting_spinner";
var IgnoreEntryWrapper = React.createClass({
  getInitialState: function() {
    return {
      loading: true,
      documentBatch: null,
      error: false
    };
  },
  componentDidMount: function() {
    documentsService.getUncachedDocumentBatch(this.props.documentBatchId).then(
      (documentBatch) => {
        this.setState({ loading: false, documentBatch });
      },
      () => {
        this.setState({ loading: false, error: true });
      }
    );
  },
  render: function() {
    if (this.state.loading) {
      return /* @__PURE__ */ React.createElement(WaitingSpinner, { when: true });
    }
    if (this.state.error) {
      return /* @__PURE__ */ React.createElement("div", { className: "error" }, "Could not load the batch to ignore.");
    }
    return /* @__PURE__ */ React.createElement(
      IgnoreEntryView,
      {
        documentBatch: this.state.documentBatch,
        onCancel: this.props.onCancel,
        ignoreEntryComplete: this.props.onComplete
      }
    );
  }
});
export default IgnoreEntryWrapper;
